// extracted by mini-css-extract-plugin
export default {"form":"BannerList_form__b0p3i"};